export type DateGroupingKey = 'Day' | 'Week' | 'Month' | 'Quarter' | 'Year';

export interface DateGroupingOption {
  value: DateGroupingKey;
  label: string;
}

export const DATE_GROUPING_OPTIONS: DateGroupingOption[] = [
  { value: 'Week', label: 'Weekly' },
  { value: 'Month', label: 'Monthly' },
  { value: 'Quarter', label: 'Quarterly' }
];
